import { defineComponent, resolveComponent, openBlock, createElementBlock, Fragment, renderList, createBlock, resolveDynamicComponent, mergeProps, withModifiers, withCtx, createTextVNode, toDisplayString, createCommentVNode, createVNode } from 'vue';
import TvbArrowIcon from '../../Icon/Arrow.vue.mjs';

const _hoisted_1 = { class: "tvb-sub-menu" };
const _hoisted_2 = {
  key: 1,
  class: "tvb-sub-menu-item-sub"
};
const __default__ = defineComponent({
  name: "TvbSubMenu"
});
var _sfc_main = /* @__PURE__ */ defineComponent({
  ...__default__,
  props: {
    menus: null,
    h: null,
    menuKey: null
  },
  emits: ["click"],
  setup(__props, { emit: emits }) {
    ;
    return (_ctx, _cache) => {
      const _component_TvbSubMenu = resolveComponent("TvbSubMenu");
      return openBlock(), createElementBlock("div", _hoisted_1, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(__props.menus, (menu, index) => {
          return openBlock(), createBlock(resolveDynamicComponent((menu == null ? void 0 : menu.jump_url) ? "a" : "span"), mergeProps({ key: index }, {
            rel: (menu == null ? void 0 : menu.link_rel) === 1 ? "follow" : (menu == null ? void 0 : menu.link_rel) === 2 ? "nofollow" : "",
            target: (menu == null ? void 0 : menu.link_target) === 1 ? "_self" : (menu == null ? void 0 : menu.link_target) === 2 ? "_blank" : ""
          }, {
            class: "tvb-sub-menu-item",
            href: (menu == null ? void 0 : menu.jump_url) || null,
            onClick: withModifiers((event) => emits("click", { ...menu, event, event_label: "main-sub-menu" }), ["stop"])
          }), {
            default: withCtx(() => {
              var _a, _b;
              return [
                (openBlock(), createBlock(resolveDynamicComponent(__props.h ? `h${__props.h}` : "span"), { class: "tvb-sub-menu-item-text" }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(menu == null ? void 0 : menu.title), 1)
                  ]),
                  _: 2
                }, 1024)),
                ((_a = menu == null ? void 0 : menu.sub_menu) == null ? void 0 : _a.length) ? (openBlock(), createBlock(TvbArrowIcon, {
                  key: 0,
                  class: "tvb-sub-menu-item-arrow"
                })) : createCommentVNode("v-if", true),
                ((_b = menu == null ? void 0 : menu.sub_menu) == null ? void 0 : _b.length) ? (openBlock(), createElementBlock("div", _hoisted_2, [
                  createVNode(_component_TvbSubMenu, {
                    menus: menu == null ? void 0 : menu.sub_menu,
                    "menu-key": menu == null ? void 0 : menu.title,
                    h: 4,
                    onClick: (event) => emits("click", { menu, ...event, event_label: "main-sub-menu" })
                  }, null, 8, ["menus", "menu-key", "onClick"])
                ])) : createCommentVNode("v-if", true)
              ];
            }),
            _: 2
          }, 1040, ["href", "onClick"]);
        }), 128))
      ]);
    };
  }
});

export { _sfc_main as default };
//# sourceMappingURL=Menu.vue2.mjs.map
